"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.locationSortOption = void 0;
exports.locationSortOption = [
    {
        id: 1,
        name: 'Newest First',
        sort: { _id: -1 },
    },
    {
        id: 2,
        name: 'Oldest First',
        sort: { _id: 1 },
    },
    {
        id: 3,
        name: 'Leads',
        sort: { 'lead.total': -1 },
    },
    {
        id: 4,
        name: 'Location Views',
        sort: { view_count: -1 },
    },
    {
        id: 5,
        name: 'Vehicle Views',
        sort: { vehicle_view_count: -1 },
    },
    {
        id: 6,
        name: 'Vehicle Count',
        sort: { 'statistic.total': -1 },
    },
    {
        id: 7,
        name: 'Name',
        sort: { name: 1 },
    },
    {
        id: 8,
        name: 'Location ID',
        sort: { location_id: 1 },
    },
    {
        id: 9,
        name: 'Zip Code',
        sort: { zip_code: 1 },
    },
];
